module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "title": "Atenção",
      "description": "Aqui você visualizar o histórico de atendimento dessa consulta"
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaAcompanhamento,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableInputSearch": "",
      "disableCheckAll": "",
      "disabledConfigCell": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c5b964"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/consulta/acompanhamento/index.vue
// module id = 1471
// module chunks = 45